import type { keyPair } from "@repo/models";

import { TLPComponents } from "@repo/ui";
import { AuditEditorInternal, PendingChangesProvider as AuditPendingChangesProvider } from "audit-editor";

interface AuditEditorProps {
	code: string;
	defaultValues: keyPair<any>[];
}

export function AuditEditor(props: AuditEditorProps) {
	return (
		<AuditPendingChangesProvider>
			<AuditEditorInternal {...props} />
			<TLPComponents showToastContainer={false} />
		</AuditPendingChangesProvider>
	);
}
